<template>
  <div class="col-lg-2 col-md-2 col-4">
    <a @click="insertDownload">
      <div class="download d-flex justify-content-center align-items-center flex-column">
        <img :src="`/static/images/downloadIcons/` + format + `.svg`" class="img-fluid" alt="">
        <h5>Download</h5>
      </div>
    </a>
  </div>
</template>

<script>
export default{
  name: 'DownloadIcon',
  props: ['link', 'format'],
  data () {
    return {}
  },
  computed: {
    downloadLink () {
      return process.env.API_URL + '/download/' + this.$route.params.type + '/' +
              this.$route.params.id + '/' + this.format + '/file'
    }
  },
  methods: {
    insertDownload () {
      this.$parent.insertDownload(this.downloadLink)
    }
  }
}
</script>

<style scoped>
a {
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadIcon.vue